import {
    executeFetch,
    getBaseEndpointWithInstance,
    getEndpointWithInstanceAndDataset,
    stringifyIfObject
} from "./graph-api";
import {getSPARQLEndpointPathFromAppConfig} from "../Configs";
import {getDatasetLabel, isRequestSuccessful, toArray} from "../components/util";
import {ALIAS_MANAGEMENT_LINKED_TO, HTTP_HEADER_CONTENT_TYPE, MEDIA_TYPE_JSON_LD} from "../Constants";
import {
    BACKEND_PATH_MANAGEMENT_AI_MESSAGES,
    BACKEND_PATH_MANAGEMENT_AI_MODELS,
    BACKEND_PATH_MANAGEMENT_AI_MODELS_TRAINING_DATA,
    BACKEND_PATH_MANAGEMENT_AI_MODELS_TRAINING_METRICS
} from "./backend-paths";
import qs from "qs";

export async function generateQuery(message, baseIRIs, classIRIs, propertyIRIs, model, userMessageTemplate) {
    const init = { 'query' : message};
    const toArray1 = toArray(classIRIs);
    if(toArray1.length > 0) {
        init['classIRIs'] = toArray1.join(",");
    }
    const toArray2 = toArray(propertyIRIs);
    if(toArray2.length > 0) {
        init['propertyIRIs'] = toArray2.join(",");
    }
    const toArray3 = toArray(baseIRIs);
    if(toArray3.length > 0) {
        init['baseIRIs'] = toArray3.join(",");
    }
    if(model) {
        init['model'] = model
    }
    if(userMessageTemplate) {
        init['userMessageTemplate'] = userMessageTemplate
    }
    const body = new URLSearchParams(init);
    const requestOptions = {
        method: "POST",
        body,
        headers: {
            "Accept": "application/json"
        }
    }

    let r = await executeFetch(getEndpointWithInstanceAndDataset(), requestOptions, 'ai/generate/SPARQL');
    if (r.status === 200) {
        const j = await r.json()
        return j;
    }
    return Promise.reject(r.text());

}

export async function chatCompletion(messages, model) {
    const paramsMap = { 'model' : model};
    const requestOptions = {
        method: "POST",
        body : stringifyIfObject(messages),
        headers: {
            "Accept": "application/json",
            [HTTP_HEADER_CONTENT_TYPE]: "application/json"
        }
    }
    const pathWithParams = `ai/chat/completions?${qs.stringify(paramsMap, {
        indices: false
    })}`
    return await executeFetch(getEndpointWithInstanceAndDataset(), requestOptions, pathWithParams);
}

export async function deleteModel(payload, ) {
    const contentType = MEDIA_TYPE_JSON_LD
    const data = {
        method: "DELETE",
        body: stringifyIfObject(payload),
        headers: {
            [HTTP_HEADER_CONTENT_TYPE]: contentType,
        }
    }
    return executeFetch(getBaseEndpointWithInstance() , data, BACKEND_PATH_MANAGEMENT_AI_MODELS)
}

export async function createModel(payload) {
    const contentType = MEDIA_TYPE_JSON_LD
    const data = {
        method: "POST",
        body: stringifyIfObject(payload),
        headers: {
            [HTTP_HEADER_CONTENT_TYPE]: contentType,
        }
    }

    const datasetLabel = getDatasetLabel();
    let paramsMap = {
        'dataset' : datasetLabel
    }
    const pathWithParams = `${BACKEND_PATH_MANAGEMENT_AI_MODELS}?${qs.stringify(paramsMap, {
        indices: false
    })}`

    return executeFetch(getBaseEndpointWithInstance() , data, pathWithParams)
}

export async function getModelTrainingData(modelId) {
    const paramsMap = { 'modelId' : modelId};

    const contentType = MEDIA_TYPE_JSON_LD
    const data = {
        method: "GET",
        headers: {
            [HTTP_HEADER_CONTENT_TYPE]: contentType,
        }
    }
    const pathWithParams = `${BACKEND_PATH_MANAGEMENT_AI_MODELS_TRAINING_DATA}?${qs.stringify(paramsMap, {
        indices: false
    })}`
    return executeFetch(getBaseEndpointWithInstance() , data, pathWithParams)
}

export async function getModelMetricsData(modelId) {
    //return {data : CSVToArray(atob('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'))};
    const paramsMap = { 'modelId' : modelId};

    const contentType = MEDIA_TYPE_JSON_LD
    const data = {
        method: "GET",
        headers: {
            [HTTP_HEADER_CONTENT_TYPE]: contentType,
        }
    }
    const pathWithParams = `${BACKEND_PATH_MANAGEMENT_AI_MODELS_TRAINING_METRICS}?${qs.stringify(paramsMap, {
        indices: false
    })}`
    let response = await executeFetch(getBaseEndpointWithInstance() , data, pathWithParams)
    if(isRequestSuccessful(response)) {
        const json = await response.json();
        const contentArray = toArray(json.content);
        if(contentArray.length >0) {
            const content = contentArray[0];
            const csv = atob(content);
            return {data : CSVToArray(csv)};
        }
    }
    return {'error' : response};
}

export async function getModelUsageData(modelId) {
    const paramsMap = { 'modelId' : modelId};

    const contentType = MEDIA_TYPE_JSON_LD
    const data = {
        method: "GET",
        headers: {
            [HTTP_HEADER_CONTENT_TYPE]: contentType,
        }
    }
    const pathWithParams = `${BACKEND_PATH_MANAGEMENT_AI_MODELS_TRAINING_METRICS}?${qs.stringify(paramsMap, {
        indices: false
    })}`
    let response = await executeFetch(getBaseEndpointWithInstance() , data, pathWithParams)
    if(isRequestSuccessful(response)) {
        const json = await response.json();
        const contentArray = toArray(json.content);
        if(contentArray.length >0) {
            const content = contentArray[0];
            const csv = atob(content);
            return {data : CSVToArray(csv)};
        }
    }
    return {'error' : response};
}

function CSVToArray( strData, strDelimiter ){
    // Check to see if the delimiter is defined. If not,
    // then default to comma.
    strDelimiter = (strDelimiter || ",");

    // Create a regular expression to parse the CSV values.
    var objPattern = new RegExp(
        (
            // Delimiters.
            "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +

            // Quoted fields.
            "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

            // Standard fields.
            "([^\"\\" + strDelimiter + "\\r\\n]*))"
        ),
        "gi"
    );


    // Create an array to hold our data. Give the array
    // a default empty first row.
    var arrData = [[]];

    // Create an array to hold our individual pattern
    // matching groups.
    var arrMatches = null;


    // Keep looping over the regular expression matches
    // until we can no longer find a match.
    while (arrMatches = objPattern.exec( strData )){

        // Get the delimiter that was found.
        var strMatchedDelimiter = arrMatches[ 1 ];

        // Check to see if the given delimiter has a length
        // (is not the start of string) and if it matches
        // field delimiter. If id does not, then we know
        // that this delimiter is a row delimiter.
        if (
            strMatchedDelimiter.length &&
            strMatchedDelimiter !== strDelimiter
        ){

            // Since we have reached a new row of data,
            // add an empty row to our data array.
            arrData.push( [] );

        }

        var strMatchedValue;

        // Now that we have our delimiter out of the way,
        // let's check to see which kind of value we
        // captured (quoted or unquoted).
        if (arrMatches[ 2 ]){

            // We found a quoted value. When we capture
            // this value, unescape any double quotes.
            strMatchedValue = arrMatches[ 2 ].replace(
                new RegExp( "\"\"", "g" ),
                "\""
            );

        } else {

            // We found a non-quoted value.
            strMatchedValue = arrMatches[ 3 ];

        }


        // Now that we have our value string, let's add
        // it to the data array.
        arrData[ arrData.length - 1 ].push( strMatchedValue );
    }

    // Return the parsed data.
    return( arrData );
}

export async function getModels(linkedTo) {
    const paramsMap = {};
    if(linkedTo) {
        paramsMap[ALIAS_MANAGEMENT_LINKED_TO] = linkedTo;
    }

    const contentType = MEDIA_TYPE_JSON_LD
    const data = {
        method: "GET",
        headers: {
            [HTTP_HEADER_CONTENT_TYPE]: contentType,
        }
    }
    const pathWithParams = `${BACKEND_PATH_MANAGEMENT_AI_MODELS}?${qs.stringify(paramsMap, {
        indices: false
    })}`
    return executeFetch(getBaseEndpointWithInstance() , data, pathWithParams)
}



export async function runSPARQLQuery(query) {
    const body = new URLSearchParams({ 'query' : query});
    const requestOptions = {
        method: "POST",
        body,
        headers: {
            "Accept": "application/sparql-results+json",
            "Content-Type" : "application/x-www-form-urlencoded; charset=UTF-8"
        }
    }

    let r = await executeFetch(getEndpointWithInstanceAndDataset(), requestOptions, getSPARQLEndpointPathFromAppConfig());
    if (r.status === 200) {
        const j = await r.json()
        return j;
    }

    return Promise.reject(r.text());
}

export async function runSPARQLConstructQuery(query) {
    const body = new URLSearchParams({ 'query' : query});
    const requestOptions = {
        method: "POST",
        body,
        headers: {
            "Content-Type" : "application/x-www-form-urlencoded; charset=UTF-8"
        }
    }

    let r = await executeFetch(getEndpointWithInstanceAndDataset(), requestOptions, getSPARQLEndpointPathFromAppConfig());
    if (r.status === 200) {
        const j = await r.text()
        return j;
    }

    return Promise.reject(r.text());
}

export function postMessages(payload, mediaType) {
    const contentType = mediaType ? mediaType : MEDIA_TYPE_JSON_LD
    const data = {
        method: "POST",
        body: payload,
        headers: {
            [HTTP_HEADER_CONTENT_TYPE]: contentType,
        }
    }
    return executeFetch(getBaseEndpointWithInstance() , data, BACKEND_PATH_MANAGEMENT_AI_MESSAGES)
}

export function patchMessages(payload, mediaType) {
    const contentType = mediaType ? mediaType : MEDIA_TYPE_JSON_LD
    const data = {
        method: "PATCH",
        body: payload,
        headers: {
            [HTTP_HEADER_CONTENT_TYPE]: contentType,
        }
    }
    return executeFetch(getBaseEndpointWithInstance() , data, BACKEND_PATH_MANAGEMENT_AI_MESSAGES)
}

export function deleteMessages(payload, mediaType) {
    const contentType = mediaType ? mediaType : MEDIA_TYPE_JSON_LD
    const data = {
        method: "DELETE",
        body: stringifyIfObject(payload),
        headers: {
            [HTTP_HEADER_CONTENT_TYPE]: contentType,
        }
    }
    return executeFetch(getBaseEndpointWithInstance() , data, BACKEND_PATH_MANAGEMENT_AI_MESSAGES)
}

export function postBatchMessages(payload, mediaType) {
    const contentType = mediaType ? mediaType : MEDIA_TYPE_JSON_LD
    const data = {
        method: "POST",
        body: stringifyIfObject(payload),
        headers: {
            [HTTP_HEADER_CONTENT_TYPE]: contentType,
        }
    }
    return executeFetch(getBaseEndpointWithInstance() , data, BACKEND_PATH_MANAGEMENT_AI_MESSAGES)
}
